export default {
  type: 'layoutRows',
  shadow: '@theme:card.shadow',
  fontName: '@theme:card.fontName',
  bgColor: 'white',
  border: true,
  borderWidth: '1',
  padding: '0',
  fontSize: '3',
  separatorJourneyTypeProps: {
    content: '|',
  },
  showJourneyType: true,
  fareItemJourneyType: {},
  showTravelClass: true,
  fareItemTravelClass: {},
  fareItemOriginDestination: {
    showOriginAirportCode: true,
    showDestinationAirportCode: true,
    showOriginLabel: true,
    showDestinationLabel: true,
    showSeparator: false,
    showLineSeparator: true,
    fontSize: '4',
    textTransform: 'uppercase',
    marginBottom: '2',
    style: {
      lineHeight: '1',
    },
    originLabelStyles: {
      paddingRight: '1',
      fontWeight: 'bold',
    },
    destinationLabelStyles: {
      paddingRight: '1',
      fontWeight: 'bold',
    },
    originAirportCodeStyles: {
      paddingRight: '1',
      fontWeight: 'bold',
    },
    destinationAirportCodeStyles: {
      paddingRight: '1',
      fontWeight: 'bold',
    },
    lineSeparatorStyles: {
      marginBottom: '1',
    },
  },
  showRoute: false,
  fareItemRoute: {
    fontWeight: 'bold',
    fontSize: '4',
    paddingBottom: '1',
    separatorLabel: {
      content: 'minus',
    },
  },
  showDepartureInfo: true,
  fareItemDepartureInfo: {
    showDepartureText: false,
    showDepartureDate: true,
    departureTextLabelStyle: {
      fontWeight: 'bold',
    },
  },
  separatorDatesProps: {
    content: 'minus',
  },
  showReturnInfo: true,
  fareItemReturnInfo: {
    showReturnText: false,
    showReturnDate: true,
    returnTextLabelStyles: {
      fontWeight: 'bold',
    },
  },
  showOriginDestinationImage: true,
  fareItemOriginDestinationImage: {
    heightDestinationImage: 100,
    widthDestinationImage: 100,
    roundedCircle: true,
  },
  showPrice: true,
  fareItemPrice: {
    pricePromoLabelKey: 'cmp-fare-price-promo-short',
    fontSize: '5',
    textAlign: 'right',
    fontWeight: 'bold',
    marginLeft: '3',
    showCurrencyCode: true,
    showCurrencySymbol: false,
    showPricePromo: true,
    pricePromoStyles: {
      fontWeight: 'normal',
      fontSize: '3',
    },
    currencyStyles: {
      textColor: 'black',
    },
  },
  fareImageItem: {
    grow: '1',
    padding: '3',
    paddingHeight: '4',
  },
  fareContentItem: {
    grow: '3',
    padding: '2',
  },
  fareBodyItem: {
    textColor: 'dark',
  },
  fareFooterItem: {
    alignItems: 'end',
    textColor: 'dark',
  },
  showDurationTrip: false,
  fareItemTripDuration: {},
  showLastSeen: true,
  fareItemLastSeen: {
    shadow: '@theme:card.shadow',
    rounded: '@theme:badge.rounded',
    fontName: '@theme:card.fontName',
    bgColor: 'light',
    padding: '1',
    marginLeft: 'auto',
    labelStyles: {
      fontWeight: 'bold',
      textColor: 'dark',
    },
    dateStyles: {
      textColor: 'dark',
    },
  },
  showAirline: false,
  fareItemAirline: {
    showAirlineLogo: true,
    showAirlineName: true,
    borderTop: true,
    airlineNameStyles: {
      fontSize: '3',
    },
  },
  showFareDisclaimer: false,
  fareItemDisclaimer: {
    borderTop: true,
    fontSize: '3',
    paddingWidth: '2',
  },
  showCallToAction: false,
  fareItemCallToAction: {
    shadow: '@theme:button.shadow',
    rounded: '@theme:button.rounded',
    width: '100',
    paddingHeight: '2',
    textTransform: 'uppercase',
    fontSize: '4',
    fontWeight: 'bold',
  },
};
